export default "__VITE_ASSET__lyA9mHuh__"